import { render, staticRenderFns } from "./HoldOrderModel.vue?vue&type=template&id=09ad7280&scoped=true&"
import script from "./HoldOrderModel.vue?vue&type=script&lang=js&"
export * from "./HoldOrderModel.vue?vue&type=script&lang=js&"
import style0 from "./HoldOrderModel.vue?vue&type=style&index=0&id=09ad7280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ad7280",
  null
  
)

export default component.exports